<h2 mat-dialog-title>{{headerLabel}}</h2>
<mat-dialog-content>
  <div style="overflow: hidden;">
    <div *ngIf = "cotrolType == 'column'">
      <mat-radio-button id="rbLeft" [checked]="location == 'left'" [value]="'left'" (click)="SetRadioValue('left')">
        Left of current column
      </mat-radio-button>
      <br>
      <mat-radio-button id="rbRight" [checked]="location == 'right'" [value]="'right'" (click)="SetRadioValue('right')">
        Right of current column
      </mat-radio-button>
    </div>
    <div *ngIf = "cotrolType != 'column'">
      <mat-radio-button id="rbAbove" [checked]="location == 'above'" [value]="'above'" (click)="SetRadioValue('above')">
        Above current row
      </mat-radio-button>
      <br>
      <mat-radio-button id="rbBelow" [checked]="location == 'below'" [value]="'below'" (click)="SetRadioValue('below')">
        Below current row
      </mat-radio-button>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-left'>

  </div>
  <div class='flex-footer-right'>
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>